module.exports = __webpack_public_path__ + "img/coupon-received.png?v=6d9519aa";